import Entity from "./entity";
import {eventNotificationClick} from "api";

export default function($app) {
	const $player = $app.require('player');
	const node = {};

	const __construct = () => {
		node.root = $('#notificationContainer');
		node.content = node.root.find('.content');
		node.link = node.content.parent();
		node.root.find('.overlay-close')
			.off('click')
			.on('click', () => node.root.slideUp(500))
		;

		$app.require('comet')
			.on('event/notification', (message) => {
				if($player.showMessage) {
					$player.showMessage(message, () => eventNotificationClick(message.id));
				} else {
					this.show(message);
				}
			})
		;
	};

	this.message = ko.observable(null);

	this.style = ko.computed(() => {
		const style = {};
		if(this.message()) {
			if(this.message().banner()) {
				style['background-image'] = `url(${this.message().banner()})`;

				if(this.message().bannerWidth() && this.message().bannerHeight()) {
					style.width = this.message().bannerWidth() + 'px';
					style.height = this.message().bannerHeight() + 'px';
					style.marginLeft = this.message().bannerWidth() / 2 * -1 + 'px';
				}
			}
		}
		return style;
	});

	this.close = () => this.message(null);

	this.show = (data) => {
		this.message(new Entity.Notification(data));
		if(this.message().time()) {
			setTimeout(() => this.close(), this.message().time() * 1000);
		}
	};

	$app.on('start', () => __construct());
};
